import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyerCountries, buyerNames } from '../data/content';
type Purchase = {
  name: string;
  country: string;
  minutes: number;
};
function randomPurchase(): Purchase {
  return {
    name: buyerNames[Math.floor(Math.random() * buyerNames.length)],
    country: buyerCountries[Math.floor(Math.random() * buyerCountries.length)],
    minutes: Math.floor(Math.random() * 12) + 1
  };
}
export function PurchasePopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setPurchase(randomPurchase());
      hideTimer = window.setTimeout(() => setPurchase(null), 6000);
    };
    const firstTimer = window.setTimeout(show, 7000);
    const interval = window.setInterval(show, 22000);
    return () => {
      window.clearTimeout(firstTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  return <AnimatePresence data-id="element-38" data-mp="114tji4p4dia6">
      {purchase && !dismissed ? <motion.div initial={{
      x: -30,
      y: 20,
      opacity: 0
    }} animate={{
      x: 0,
      y: 0,
      opacity: 1
    }} exit={{
      x: -30,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 28
    }} className="fixed bottom-24 left-3 right-3 z-30 mx-auto max-w-[21rem] rounded-2xl border border-navy/10 bg-white p-3 shadow-[0_18px_40px_-18px_rgba(10,31,68,0.5)] sm:left-5 sm:right-auto sm:bottom-28" role="status" data-id="element-39" data-mp="1fur2854a5frz">
          <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-navy/30 transition-colors hover:bg-navy/5 hover:text-navy" data-id="element-40" data-mp="s5omj2t7hx04">
            <XIcon className="h-3.5 w-3.5" data-id="element-41" data-mp="23nps89k1laf1" />
          </button>
          <div className="flex items-start gap-3 pr-4" data-id="element-42" data-mp="2ao1mowszbnp8">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-43" data-mp="2fn4u2nwfm60d">
              <CheckCircle2Icon className="h-5 w-5 text-gold" data-id="element-44" data-mp="2kmhfd47nn50u" />
            </span>
            <div data-id="element-45" data-mp="2plk8bqad1ksg">
              <p className="text-[13px] font-bold leading-snug text-navy" data-id="element-46" data-mp="2pm3ujj71mvca">
                {purchase.name} from {purchase.country}
              </p>
              <p className="text-[12px] leading-snug text-navy/60" data-id="element-47" data-mp="1rvz43fws1xcc">
                just purchased the Menopause Clinical Blueprint™
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-gold-dark" data-id="element-48" data-mp="21vznf1uncdgj">
                {purchase.minutes} min ago
              </p>
            </div>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}